// The rejected-action middleware already toasts backend errors. This pulls the
// same message out so the modal can keep it on screen next to the button that
// failed, instead of the user only catching a toast that has since faded.
const getBackendError = (error: unknown): string => {
  if (!error) return "";
  const data = (error as { data?: any })?.data ?? error;

  if (typeof data === "string") return data;
  if (typeof data?.detail === "string") return data.detail;
  if (Array.isArray(data?.detail)) return data.detail.join(", ");
  if (typeof data?.details?.reason === "string") return data.details.reason;
  if (Array.isArray(data?.details)) return data.details.join(", ");
  if (typeof data?.message === "string") return data.message;

  const firstKey = data && typeof data === "object" ? Object.keys(data)[0] : "";
  if (firstKey) {
    const value = data[firstKey];
    return Array.isArray(value) ? String(value[0]) : String(value);
  }

  return "Something went wrong. Please try again later.";
};

export default getBackendError;
